import { request } from 'utils/tool';
import { PREFIX } from 'constants/host';
import Notify from 'ui-component/Tools/Notify';
import { store } from 'store';
import { SET_USER_INFO } from 'store/userReducer';
import { getResult } from './common';
import { HIDE_SERVICE } from 'constants/common';

export const registerUser = async (options: { code: string; password: string; mobile: string; name: string }) => {
  const res = getResult<boolean>(await request.post(`${PREFIX}/user/register`, options));
  if (!res.success) {
    Notify('error', res.msg);
  }
  return res;
};

export const getRegisterCode = async (options: { country: string; mobile: string }) => {
  const res = getResult<{
    smsSeqNo: number;
    success: boolean;
  }>(await request.post(`${PREFIX}/sms/user/register`, options));
  if (!res.success) {
    Notify('error', res.msg);
  }
  return res;
};

export const getRegisterMailCode = async (options: { mail: string }) => {
  const res = getResult<boolean>(await request.post(`${PREFIX}/sms/user/register/mail/code`, options));
  if (!res.success) {
    Notify('error', res.msg);
  }
  return res;
};

export const registerUserByCode = async (options: { smsCode: string; code: string; password: string; mobile: string; name: string }) => {
  const res = getResult<boolean>(await request.post(`${PREFIX}/user/auth/create`, options));
  if (!res.success) {
    Notify('error', res.msg);
  }
  return res;
};

export const loginByGoogle = async (options: any) => {
  const res = getResult<any>(await request.post(`${PREFIX}/user/mfa/verify`, options));
  if (!res.success) {
    Notify('error', res.msg);
  }
  return res;
};

export const loginByPassword = async (options: { mobile?: string; password: string; loginMethod: string; mail?: string }) => {
  const res = getResult<{
    token: string;
    authType: string;
    mfa?: {
      mfaId: string;
    };
  }>(await request.post(`${PREFIX}/user/login`, options));
  if (!res.success) {
    Notify('error', res.msg);
  }
  return res;
};

export const userLogout = async () => {
  const res = getResult<boolean>(await request.post(`${PREFIX}/user/logout`));
  if (!res.success) {
    Notify('error', res.msg);
  } else {
    // if (window.tidioChatApi) {
    //   window.tidioChatApi.display(false);
    // }
  }
  return res;
};

export type UserDetail = {
  overview: {
    balance: number;
    consume: number;
    deposit: number;

    declineNum: number; // 拒付数
    declineRatio: number; // 拒付率
    pendingNum: number; // pending数
    vccNum: number; // 开卡数
    vccTotalNum: number; // 总开卡数
    refundNum: number; // 退款数
    refundRatio: number; // 退款率
    completeRatio: number; // 支付成功率
    cardConfig?: any;
    totalDeposit: number; // 总充值
    vccOnlineNum: number; // 激活卡片数
    vccDeletedNum: number; // 累计删卡
    showTopupCostPreview: boolean;
    showUsdtTopupCostPreview: boolean;
    availableAccountCurrency: string[];
    usdtTron?: string;
    futureTron?: {
      address?: string;
      enable: boolean;
    };
    coinTron?: {
      address?: string;
      enable: boolean;
    };
    authConfig?: {
      skipMfa: boolean;
      skipPinCheck: boolean;
    };
  };
  account: {
    createTime: number;
    mobile: string;
    name: string;
    userId: string;
    features: string[];
    agent: {
      showMenu: boolean;
    };
    validationResult: {
      personalIdValidationResult: 'INIT' | 'SUCCESS';
    };
  };
  featureConfig: {
    canUseYsDbBalance: boolean;
  };
  userStatus?: {
    googleAuthStatus: string;
    kycV2Status: 'INIT' | 'CHECKING' | 'SUCCESS' | 'FAILED';
  };
  inviterInfo?: {
    agentId?: string;
    contact?: string;
  };
};

export const getUserDetail = async () => {
  const res = getResult<UserDetail>(await request.get(`${PREFIX}/user/overview`));
  if (!res.success) {
    Notify('error', res.msg);
    // @ts-ignore
    if (!document.tidioIdentify) {
      // @ts-ignore
      document.tidioIdentify = {
        name: '登录页游客'
      };
      setTimeout(() => {
        const tidioScript = document.createElement('script');
        tidioScript.src = '//code.tidio.co/vghsf5l1zo1w5u2adhzakpi7rjygoy2p.js';
        document.body.appendChild(tidioScript);
        tidioScript.addEventListener('load', () => {
          // @ts-ignore
          if (HIDE_SERVICE.includes(window.location.pathname) && window.tidioChatApi) {
            // @ts-ignore
            window.tidioChatApi.display(false);
          }
        });
      }, 0);
    } else {
      // @ts-ignore
      if (window.tidioChatApi) {
        // @ts-ignore
        window.tidioChatApi.display(true);
      }
    }
  } else {
    store.dispatch(
      SET_USER_INFO({
        user: res.data!
      })
    );
    // @ts-ignore
    if (!document.tidioIdentify) {
      // @ts-ignore
      document.tidioIdentify = {
        distinct_id: res?.data?.account.userId,
        name: res.data?.account?.name,
        phone: res.data?.account?.mobile
      };
      setTimeout(() => {
        const tidioScript = document.createElement('script');
        tidioScript.src = '//code.tidio.co/vghsf5l1zo1w5u2adhzakpi7rjygoy2p.js';
        document.body.appendChild(tidioScript);
        tidioScript.addEventListener('load', () => {
          // @ts-ignore
          if (HIDE_SERVICE.includes(window.location.pathname) && window.tidioChatApi) {
            // @ts-ignore
            window.tidioChatApi.display(false);
          }
        });
      }, 0);
    } else {
      // @ts-ignore
      document.tidioIdentify = {
        distinct_id: res?.data?.account.userId,
        name: res.data?.account?.name,
        phone: res.data?.account?.mobile
      };
      // @ts-ignore
      if (window.tidioChatApi) {
        // @ts-ignore
        window.tidioChatApi.display(true);
      }
    }
  }
  return res;
};

export type Broadcast = {
  read: boolean;
  createTime: string;
  updateTime: string;
  gmtCreate: string;
  id: number;
  msg: string;
  title: string;
  popUp: boolean;
  popEndTime?: number;
  popStartTime?: number;
};

type BroadcastResult = {
  data: Broadcast[];
  current: number;
  size: number;
  total: number;
};

export const getUnReadBroadcast = async (options: { current: number; size?: number }) => {
  const res = await getResult<BroadcastResult>(await request.get(`${PREFIX}/broadcast/list`, options));
  if (!res.success) {
    Notify('error', res.msg);
  }

  return res;
};

export type Rebate = {
  cutRate: number;
  desp: string;
  rebate: number;
  rebateId: string;
  sourceTypeText: string;
  source: string;
  userId: string;
};

type RebateResult = {
  data: Rebate[];
  current: number;
  size: number;
  total: number;
};

export const getRebateList = async (options: { current: number; size?: number }) => {
  const res = await getResult<RebateResult>(await request.get(`${PREFIX}/agent/rebate/list`, options));
  if (!res.success) {
    Notify('error', res.msg);
  }
  return res;
};

export type Customer = {
  mobile: string;
  nickName: string;
  rebate: number;
  userId: string;
};

type CustomerResult = {
  data: Customer[];
  pageNo: number;
  pageSize: number;
  total: number;
};

export const getCustomerList = async (options: { current: number; size?: number }) => {
  const res = await getResult<CustomerResult>(await request.get(`${PREFIX}/agent/customer/list`, options));
  if (!res.success) {
    Notify('error', res.msg);
  }
  return res;
};

export type AgentInfo = {
  agentId: string;
  inviteCode: string;
  visitCount: number;
  invitedCount: number;
  withDrawRebate: number;
  remainRebate: number;
  minWithdrawAmount: number;
  refundCutRate?: number | string;
  blockRebate: number;
  cardTopupCutRate: number;
  totalRebate: number;
  newCardCutRate: string;
  privilegeCutRate: number;
  dataShowable: boolean;
  rebateEnable: boolean;
  showable: boolean;
  disabled: boolean;
};

export const getAgentInfo = async () => {
  const res = await getResult<AgentInfo>(await request.get(`${PREFIX}/agent/detail`));
  if (!res.success) {
    Notify('error', res.msg);
  }
  return res;
};

export const getLatestInviteCode = async () => {
  const res = await getResult<{
    inviteCode: string;
  }>(await request.get(`${PREFIX}/agent/invite-code/show-one`));
  if (!res.success) {
    Notify('error', res.msg);
  }
  return res;
};

export const refreshInviteCode = async () => {
  const res = await getResult<{
    inviteCode: string;
  }>(await request.post(`${PREFIX}/agent/invite-code/refresh`));
  if (!res.success) {
    Notify('error', res.msg);
  }
  return res;
};

export const getGoogleAuth = async () => {
  const res = await getResult<{
    qrImg: string;
  }>(await request.get(`${PREFIX}/auth/google/pair/qr/img`));
  if (!res.success) {
    Notify('error', res.msg);
  }
  return res;
};

export const bindGoogleAuth = async (option: { pin: string | number }) => {
  const res = await getResult<boolean>(await request.post(`${PREFIX}/auth/google/pair`, option));
  if (!res.success) {
    Notify('error', res.msg);
  }
  return res;
};

export const unBindGoogleAuth = async (option: { pin: string | number }) => {
  const res = await getResult<boolean>(await request.post(`${PREFIX}/auth/google/delete`, option));
  if (!res.success) {
    Notify('error', res.msg);
  }
  return res;
};

export const loginWithGoogleAuth = async (option: { pin: string | number; mobile: string }) => {
  const res = await getResult<{
    token: string;
    authType: string;
  }>(await request.post(`${PREFIX}/user/googleAuth/login`, option));
  if (!res.success) {
    Notify('error', res.msg);
  }
  return res;
};

export const loginWithSms = async (option: { smsCode: string | number; mobile: string; country: string; rememberMe?: boolean }) => {
  const res = await getResult<{
    token: string;
    authType: string;
  }>(await request.post(`${PREFIX}/user/mobile/login`, option));
  if (!res.success) {
    Notify('error', res.msg);
  }
  return res;
};

export const loginWithMailSms = async (option: { smsCode: string | number; mail: string; rememberMe?: boolean }) => {
  const res = await getResult<{
    token: string;
    authType: string;
  }>(await request.post(`${PREFIX}/user/mail/login`, option));
  if (!res.success) {
    Notify('error', res.msg);
  }
  return res;
};

export const getLoginCode = async (options: { country: string; mobile: string }) => {
  const res = getResult<{
    smsSeqNo: number;
    success: boolean;
  }>(await request.post(`${PREFIX}/sms/user/mobile/login`, options));
  if (!res.success) {
    Notify('error', res.msg);
  }
  return res;
};

export const getLoginMailCode = async (options: { mail: string }) => {
  const res = getResult<{
    smsSeqNo: number;
    success: boolean;
  }>(await request.post(`${PREFIX}/sms/user/mail/login`, options));
  if (!res.success) {
    Notify('error', res.msg);
  }
  return res;
};

export const getVerifyCode = async () => {
  const res = getResult<{
    smsSeqNo: number;
    success: boolean;
  }>(await request.post(`${PREFIX}/sms/verify/code`));
  if (!res.success) {
    Notify('error', res.msg);
  }
  return res;
};
export const getVerifyMailCode = async () => {
  const res = getResult<{
    smsSeqNo: number;
    success: boolean;
  }>(await request.post(`${PREFIX}/sms/verify/mail/code`));
  if (!res.success) {
    Notify('error', res.msg);
  }
  return res;
};

export const resetPassword = async (option: { pin: string | number; mobile: string; password: string; verifyMethod?: any }) => {
  const res = await getResult<boolean>(await request.post(`${PREFIX}/user/reset-password`, option));
  if (!res.success) {
    Notify('error', res.msg);
  }
  return res;
};

export type KYCResult = {
  kycLogId: string;
  url: string;
};

export const createPersonalKyc = async (options: { category: string; country: string; idName: string; idNumber: string }) => {
  const result = getResult<KYCResult>(await request.post(`${PREFIX}/validation/user/id/auth`, options));
  if (!result.success) {
    Notify('error', result.msg);
  }
  return result;
};

export const createPersonalKycOneTime = async (options: { oneTimeKycType: string }) => {
  const result = getResult<KYCResult>(await request.post(`${PREFIX}/validation/user/oneTimeKyc`, options));
  if (!result.success) {
    Notify('error', result.msg);
  }
  return result;
};

export const getKycResult = async (options: { kycLogId: string }) => {
  const result = getResult<any>(await request.get(`${PREFIX}/validation/history/result`, options));
  if (!result.success) {
    Notify('error', result.msg);
  }
  return result;
};

export type HeaderBroadcast = {
  createTime: string;
  updateTime: string;
  gmtCreate: string;
  id: number;
  msg: string;
  title: string;
  endTime?: number;
  startTime?: number;
};

type HeaderBroadcastResult = {
  data: HeaderBroadcast[];
  current: number;
  size: number;
  total: number;
};

export const getHeaderBroadcast = async (options: { current: number; size?: number }) => {
  const res = await getResult<HeaderBroadcastResult>(await request.get(`${PREFIX}/cms/headerBar/list`, options));
  if (!res.success) {
    Notify('error', res.msg);
  }

  return res;
};

export type PaymentStatus = {
  failedTryTimes: number;
  status: 'FAILED' | 'FROZEN' | 'INIT' | 'NOT_SET' | 'PASS';
  ttl: number;
  ttlText: string;
};

export const checkPaymentPassword = async (options: { pin: string; rememberMe?: boolean }) => {
  const res = await getResult<PaymentStatus>(await request.post(`${PREFIX}/pinCheck/check`, options));
  if (!res.success) {
    Notify('error', res.msg);
  }

  return res;
};

export type DeviceListItem = {
  gmtCreate: number;
  id: number;
  invalidate: boolean;
  ip: string;
  lastLoginTime: number;
  loginMethod: string;
  loginMethodText: string;
  userAgentInfo: string;
  userId: string;
};

type DeviceListResult = {
  data: DeviceListItem[];
  current: number;
  size: number;
  total: number;
};

export const getDeviceList = async (options: { current: number; size?: number }) => {
  const res = await getResult<DeviceListResult>(await request.get(`${PREFIX}/session/loginDevice/list`, options));
  if (!res.success) {
    Notify('error', res.msg);
  }

  return res;
};

export const logoutDevice = async (options: { pin: string; id: number }) => {
  const res = await getResult<boolean>(await request.post(`${PREFIX}/session/loginDevice/invalidate`, options));
  if (!res.success) {
    Notify('error', res.msg);
  }

  return res;
};

export const submitKyc = async (options: any) => {
  const res = await getResult<boolean>(await request.post(`${PREFIX}/validationV2/submit`, options));
  if (!res.success) {
    Notify('error', res.msg);
  }

  return res;
};

export type KycInfo = {
  attachments: string[];
  birthDate: number;
  expireDate: number;
  fullName: string;
  gender: string;
  gmtCreate: number;
  gmtModified: number;
  id: string;
  idCountry: string;
  idNumber: string;
  idType: string;
  reason: string;
  status: 'INIT' | 'CHECKING' | 'SUCCESS' | 'FAILED';
  userId: string;
  validType: string;
};

export const getKycInfo = async () => {
  const res = await getResult<KycInfo>(await request.get(`${PREFIX}/validationV2/detail`));
  if (!res.success) {
    Notify('error', res.msg);
  }

  return res;
};
